import _ from "lodash";
import QueryQrcodes from 'graphql/queries/QueryQrcodes'
import QueryQrcode from 'graphql/queries/QueryQrcode'
import GraphqlGroupedBuilder from 'utils/request/graphql/groupedBuilder'
import QueryQrcodeOld from 'graphql/queries/QueryQrcodeOld'

export default class FetchQrCode {
	
	static fetch( guid, { callbackSuccess = null, callbackError = null, callbackStart = null, dispatchDataToStore = false } = {}  ) {
		GraphqlGroupedBuilder.addQuery( 'qrcode', QueryQrcode, {
			variables: {
				guid: guid,
			},
			resultPath: [ 'qrcode' ],
			callbackStart,
			callbackError,
			callbackSuccess: result => {
				if( callbackSuccess !== null && _.isFunction( callbackSuccess ) ) {
					callbackSuccess({
						qrcode: result
					});
				}
			},
		})
	}
	
	static fetchOld( code, { callbackSuccess = null, callbackError = null, callbackStart = null, dispatchDataToStore = false } = {}  ) {
		GraphqlGroupedBuilder.addQuery( 'qrcode_old', QueryQrcodeOld, {
			variables: {
				guid: code,
			},
			resultPath: [ 'qrcode_scanin' ],
			callbackStart,
			callbackError,
			callbackSuccess: result => {
				if( callbackSuccess !== null && _.isFunction( callbackSuccess ) ) {
					callbackSuccess({
						qrcode: result
					});
				}
			},
		})
	}
	
	static fetchAll = ( { callbackSuccess = null, callbackError = null, callbackStart = null, variables = {} } = {} ) => {
		GraphqlGroupedBuilder.addQuery( 'qrcodes', QueryQrcodes, {
			variables,
			resultPath: [ 'qrcodes' ],
			callbackStart,
			callbackError,
			callbackSuccess: result => {
				if( callbackSuccess !== null && _.isFunction( callbackSuccess ) ) {
					callbackSuccess({
						qrcodes: result
					});
				}
			},
		})
	}
}
